// extracted by mini-css-extract-plugin
module.exports = {"container":"navigation-sidebar_container__CkHeJ","isOpen":"navigation-sidebar_isOpen__sURpG","inner":"navigation-sidebar_inner__Qj27f"};